import { isEnterpriseDistribution } from './distribution';
import { API_ORIGIN } from './network';
import { SITE } from './site';

// ESA 控制台导出的属性，必须原样保留。
export const ALIYUN_ESA_BOT_SCRIPT_ATTRIBUTES = {
  id: '6cc076e6727a87d6',
  src: 'https://o.alicdn.com/frontend-lib/common-lib/jquery.min.js',
  captchaType: 'esa',
} as const;

// 验证码规则保护的线上 API 来源。
const ESA_BOT_API_ORIGIN = 'https://service.vidu.cn';
// 正式构建仅在中国主站页面加载。
const ESA_BOT_PRODUCTION_FRONTEND_ORIGIN = 'https://www.vidu.cn';
// 本地联调入口，仅开发模式允许。
const ESA_BOT_DEVELOPMENT_FRONTEND_ORIGIN = 'https://local.dev.shu.team:3000';

const getOrigin = (value: string | undefined): string => {
  try {
    return new URL(value ?? '').origin;
  } catch {
    return '';
  }
};

const frontendOrigin = getOrigin(process.env.NEXT_PUBLIC_ORIGIN);
const apiOrigin = getOrigin(API_ORIGIN);
const isSupportedApi = apiOrigin === ESA_BOT_API_ORIGIN;
const isSupportedFrontend =
  frontendOrigin === ESA_BOT_PRODUCTION_FRONTEND_ORIGIN ||
  (process.env.NODE_ENV === 'development' && frontendOrigin === ESA_BOT_DEVELOPMENT_FRONTEND_ORIGIN);
const isRequested =
  process.env.NEXT_PUBLIC_ENABLE_ALIYUN_ESA_BOT === 'true' && SITE === 'china' && !isEnterpriseDistribution;

export const ALIYUN_ESA_BOT_ENABLED = isRequested && isSupportedApi && isSupportedFrontend;

if (process.env.NODE_ENV !== 'production' && isRequested && !ALIYUN_ESA_BOT_ENABLED) {
  const reasons: string[] = [];
  if (!isSupportedApi) {
    reasons.push(`NEXT_PUBLIC_API_ORIGIN: ${apiOrigin ? 'API origin 不受支持' : 'URL 缺失或无效'}`);
  }
  if (!isSupportedFrontend) {
    reasons.push(`NEXT_PUBLIC_ORIGIN: ${frontendOrigin ? '页面 origin 不受支持' : 'URL 缺失或无效'}`);
  }
  console.warn(`[ESA Bot SDK] 已开启但未加载：${reasons.join('；')}。`);
}
